import React from 'react';

import { Tab, Tabs } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import ROLES from 'config/constants/ROLES';
import usePermissions from 'hooks/usePermissions';
import assets_messages from 'messages/assets_messages';
import PATHS from 'router/PATHS';

const AssetRelationsTabs: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [isAssetsManager] = usePermissions([ROLES.ORGANIZATION.ASSETS_MANAGER]);
  const assetManagerTabPaths = [PATHS.ASSETS_RELATIONS, PATHS.ASSETS_YEAR_PLANNER_TEMPLATES] as string[];
  const value = isAssetsManager && assetManagerTabPaths.includes(location.pathname) ? location.pathname : PATHS.ASSETS;

  return (
    <Tabs indicatorColor='secondary' onChange={(_, nextValue) => history.push(nextValue)} textColor='secondary' value={value}>
      <Tab label={t(assets_messages.tabs.assets)} value={PATHS.ASSETS} />
      {isAssetsManager && <Tab label={t(assets_messages.tabs.relations)} value={PATHS.ASSETS_RELATIONS} />}
      {isAssetsManager && <Tab label={t(assets_messages.tabs.year_planner_templates)} value={PATHS.ASSETS_YEAR_PLANNER_TEMPLATES} />}
    </Tabs>
  );
};

export default AssetRelationsTabs;
